export type TIconButtonTheme =
  | '1'
  | '1_1 '
  | '2'
  | '2_1'
  | '6'
  | '9'
  | '8'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '19'
  | '20'
  | '21'
  | '23'
  // Дальше идут названия тем как и в ЮАй-ките в Фигме
  | 'outline'
  | 'secondary-filled'
  | 'secondary-custom'
  | 'chat-average';

export enum IconButtonShape {
  Square = 'square',
  Round = 'round',
}
